import {
    renderAccount,
    renderAircraft,
    renderDirectory,
    renderFlights,
    renderImagery,
    renderInsurance,
    renderLogbook,
    renderLogbookCTA,
    renderMap,
    renderRoster,
} from 'ff/common/components/FFMenuV2/MenuItems';
import renderDivider from 'ff/common/components/FFMenuV2/MenuItems/Divider';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';

export default function RenderNoSubscriptionMenu() {
    return [
        renderFlights,
        renderMap,
        renderImagery,
        renderAircraft,
        renderDirectory,
        renderRoster,
        renderLogbook,
        renderInsurance,
        renderDivider,
        renderAccount,
        renderLogbookCTA,
        fillSpace.bind(null, { flex: '1' }),
    ];
}
